"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _withStyles = _interopRequireDefault(require("../withStyles"));

var _classnames = _interopRequireDefault(require("classnames"));

var _downshift = _interopRequireDefault(require("downshift"));

var _reactInputAutosize = _interopRequireDefault(require("react-input-autosize"));

var _get = _interopRequireDefault(require("lodash/get"));

var _Scaffold = _interopRequireDefault(require("../Scaffold"));

var _Tag = _interopRequireDefault(require("./Tag"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var itemToString = function itemToString(item) {
  return item ? item.label : "";
};

var getSelectedItems = function getSelectedItems(props) {
  var value = props.field.value,
      items = props.items;
  var selectedItems = []; // Sometimes, we might have some this.props.field.values that aren't
  // part of the this.props.items collection that gets passed in. We'll want
  // to add these so we have access to them in this.state.selectedItems
  // (they won't show up in the dropdown items but they'll show as selected)

  if (value && value.length > 0) {
    value.forEach(function (singleValue) {
      var existingItem = items.find(function (item) {
        return singleValue.indexOf(item.value) > -1;
      });

      if (existingItem) {
        selectedItems.push(existingItem);
      } else {
        selectedItems.push({
          label: singleValue,
          value: singleValue
        });
      }
    });
  }

  return selectedItems;
};
/**
 * A component that renders a <MultiSelect /> to be used inside forms.
 */


var MultiSelect =
/*#__PURE__*/
function (_Component) {
  _inherits(MultiSelect, _Component);

  function MultiSelect(props) {
    var _this;

    _classCallCheck(this, MultiSelect);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MultiSelect).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "_input", void 0);

    _defineProperty(_assertThisInitialized(_this), "_inputWrapper", void 0);

    _defineProperty(_assertThisInitialized(_this), "setItems", function (items) {
      if (!(items && Array.isArray(items))) {
        return;
      }

      _this.setState({
        items: items
      });
    });

    _defineProperty(_assertThisInitialized(_this), "stateReducer", function (state, changes) {
      // this prevents the menu from being closed when the user
      // selects an item with a keyboard or mouse
      switch (changes.type) {
        case _downshift["default"].stateChangeTypes.keyDownEnter:
        case _downshift["default"].stateChangeTypes.clickItem:
          // Check the prop to decide whether we close the dropdown after an item is selected
          return _objectSpread({}, changes, {
            isOpen: _this.props.closeOnSelect ? false : state.isOpen
          });

        case _downshift["default"].stateChangeTypes.blurInput:
          // If a user tabs through the input, we want to make sure it's marked as
          // `touched` for formik's validation to run
          if (_this.props.form && _this.props.field) {
            _this.props.form.setFieldTouched(_this.props.field.name, true);
          } // Always close the dropdown on blur


          return {
            isOpen: false
          };

        default:
          return changes;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleStateChange", function (changes, downshiftStateAndHelpers) {
      if (!downshiftStateAndHelpers.isOpen) {
        _this.setState({
          inputValue: ""
        });
      }

      if (changes.hasOwnProperty("selectedItem")) {
        _this.onAddTag(changes.selectedItem);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onAddTag", function (item) {
      var _this$props = _this.props,
          _this$props$field = _this$props.field,
          name = _this$props$field.name,
          value = _this$props$field.value,
          setFieldValue = _this$props.form.setFieldValue,
          tags = _this$props.tags;
      var _this$state = _this.state,
          inputValue = _this$state.inputValue,
          selectedItems = _this$state.selectedItems;

      if (item) {
        var updatedSelectedItems = _toConsumableArray(selectedItems);

        updatedSelectedItems.push(item);

        _this.setState({
          selectedItems: updatedSelectedItems,
          inputValue: ""
        });

        var updatedValue = _toConsumableArray(value);

        updatedValue.push(item.value);
        setFieldValue(name, updatedValue);
      } else if (tags && inputValue !== "" && !value.includes(inputValue)) {
        var _updatedSelectedItems = _toConsumableArray(selectedItems);

        _updatedSelectedItems.push({
          label: inputValue,
          value: inputValue
        });

        _this.setState({
          selectedItems: _updatedSelectedItems,
          inputValue: ""
        });

        var _updatedValue = _toConsumableArray(value);

        _updatedValue.push(inputValue);

        setFieldValue(name, _updatedValue);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onRemoveTag", function (item) {
      var _this$props2 = _this.props,
          _this$props2$field = _this$props2.field,
          name = _this$props2$field.name,
          value = _this$props2$field.value,
          setFieldValue = _this$props2.form.setFieldValue;
      var selectedItems = _this.state.selectedItems;
      var stateIndex = selectedItems && selectedItems.findIndex(function (val) {
        return val.value === item.value;
      });

      var updatedSelectedItems = _toConsumableArray(selectedItems);

      updatedSelectedItems.splice(stateIndex, 1);

      _this.setState({
        selectedItems: updatedSelectedItems
      });

      var index = value && value.findIndex(function (val) {
        return val === item.value;
      });

      var updatedValue = _toConsumableArray(value);

      updatedValue.splice(index, 1);
      setFieldValue(name, updatedValue);
    });

    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (e) {
      var inputValue = e.target.value;

      _this.setState({
        inputValue: inputValue
      });

      if (_this.props.onSearch) {
        _this.props.onSearch({
          inputValue: inputValue,
          originalItems: _this.props.items,
          currentItems: _this.state.items,
          setItems: _this.setItems
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onInputKeyDown", function (event) {
      var currentValue = event.target.value;

      switch (event.keyCode) {
        case 8:
          // backspace
          if (!currentValue) {
            event.preventDefault();

            _this.popValue();
          }

          return;

        case 9:
          // tab
          // Blur input, close dropdown
          return;

        case 13:
          // enter
          if (currentValue !== "") {
            event.preventDefault(); // This is wrapped in a setTimeout to force it to trigger *after* the
            // built-in downshift state reducer fires (fixes a timing issue if a
            // user has typed-ahead *and* keyboard-selected an item from the dropdown)

            setTimeout(function () {
              _this.onAddTag();
            }, 1);
          }

          return;

        default:
          return;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onWrapperClick", function (e) {
      e.stopPropagation();
      e.preventDefault();

      _this.focusInput();
    });

    _defineProperty(_assertThisInitialized(_this), "inputRef", function (c) {
      _this._input = c;
    });

    _defineProperty(_assertThisInitialized(_this), "inputWrapperRef", function (c) {
      _this._inputWrapper = c;
    });

    _this.state = {
      inputValue: "",
      selectedItems: getSelectedItems(props),
      items: props.items || []
    };
    return _this;
  }

  _createClass(MultiSelect, [{
    key: "popValue",
    value: function popValue() {
      var _this$props3 = this.props,
          _this$props3$field = _this$props3.field,
          name = _this$props3$field.name,
          value = _this$props3$field.value,
          setFieldValue = _this$props3.form.setFieldValue;
      var selectedItems = this.state.selectedItems;

      var updatedSelectedItems = _toConsumableArray(selectedItems);

      updatedSelectedItems.pop();
      this.setState({
        selectedItems: updatedSelectedItems
      });

      var updatedValue = _toConsumableArray(value);

      updatedValue.pop();
      setFieldValue(name, updatedValue);
    }
    /**
     * Change state to reflect new inputValue typed by user.
     *
     * If onSearch is passed into props, call onSearch to allow AJAX autocomplete
     */

  }, {
    key: "focusInput",
    value: function focusInput() {
      this._input.focus();

      if (typeof this._input.getInput === "function") {
        this._input.getInput().focus();
      }
    }
  }, {
    key: "renderArrowIcon",
    value: function renderArrowIcon(isOpen) {
      var _this$props4 = this.props,
          classes = _this$props4.classes,
          colors = _this$props4.theme.colors;
      return _react["default"].createElement("svg", {
        className: classes.arrow,
        width: 24,
        height: 24,
        viewBox: "0 0 1792 1792",
        transform: isOpen ? "rotate(180)" : null
      }, _react["default"].createElement("path", {
        fill: colors.gray300 || "currentColor",
        d: "M1395 736q0 13-10 23l-466 466q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l393 393 393-393q10-10 23-10t23 10l50 50q10 10 10 23z"
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props,
          classes = _this$props5.classes,
          className = _this$props5.className,
          _this$props5$field = _this$props5.field,
          name = _this$props5$field.name,
          value = _this$props5$field.value,
          _this$props5$form = _this$props5.form,
          errors = _this$props5$form.errors,
          touched = _this$props5$form.touched,
          label = _this$props5.label,
          _this$props5$withScaf = _this$props5.withScaffold,
          withScaffold = _this$props5$withScaf === void 0 ? true : _this$props5$withScaf;
      var _this$state2 = this.state,
          selectedItems = _this$state2.selectedItems,
          items = _this$state2.items;
      return _react["default"].createElement(_downshift["default"], {
        itemToString: itemToString,
        stateReducer: this.stateReducer,
        onStateChange: this.handleStateChange,
        selectedItem: value
      }, function (_ref) {
        var getInputProps = _ref.getInputProps,
            getItemProps = _ref.getItemProps,
            isOpen = _ref.isOpen,
            highlightedIndex = _ref.highlightedIndex,
            openMenu = _ref.openMenu,
            closeMenu = _ref.closeMenu;

        var Input = _react["default"].createElement("div", {
          ref: _this2.inputWrapperRef,
          className: (0, _classnames["default"])(classes.root, className),
          onClick: _this2.onWrapperClick
        }, _react["default"].createElement("div", {
          className: classes.tagWrapper
        }, selectedItems.map(function (item) {
          return _react["default"].createElement(_react.Fragment, {
            key: item.value
          }, _react["default"].createElement(_Tag["default"], {
            tag: item,
            onRemove: _this2.onRemoveTag
          }), _react["default"].createElement("input", {
            type: "hidden",
            name: name,
            value: item.value
          }));
        }), _react["default"].createElement(_reactInputAutosize["default"], getInputProps({
          ref: _this2.inputRef,
          inputClassName: classes.input,
          onChange: _this2.onInputChange,
          onFocus: !isOpen ? openMenu : closeMenu,
          onKeyDown: _this2.onInputKeyDown,
          value: _this2.state.inputValue
        }))), _this2.renderArrowIcon(isOpen));

        var Dropdown = _react["default"].createElement("div", {
          className: classes.dropdown
        }, _this2.props.loading ? _react["default"].createElement("div", {
          className: classes.dropdownItem
        }, "Loading...") : null, items.filter(function (i) {
          return _this2.state.selectedItems && _this2.state.selectedItems.findIndex(function (val) {
            return val.value === i.value;
          }) === -1 && (!_this2.state.inputValue || i.label.toLowerCase().includes(_this2.state.inputValue.toLowerCase()));
        }).map(function (item, index) {
          var _classNames;

          return _react["default"].createElement("div", _extends({
            key: item.value,
            className: (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, classes.dropdownItem, true), _defineProperty(_classNames, classes.dropdownItemSelected, value && value.findIndex(function (val) {
              return val.value === item.value;
            }) > -1), _defineProperty(_classNames, classes.dropdownItemActive, highlightedIndex === index), _classNames))
          }, getItemProps({
            index: index,
            item: item
          })), itemToString(item), item.note && _react["default"].createElement("span", {
            className: classes.dropdownItemNote
          }, item.note));
        }));

        return withScaffold ? _react["default"].createElement("div", null, _react["default"].createElement(_Scaffold["default"], {
          label: label,
          error: (0, _get["default"])(touched, name) && (0, _get["default"])(errors, name)
        }, Input, isOpen && Dropdown)) : _react["default"].createElement("div", null, Input, isOpen && Dropdown);
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.items.length !== state.items.length) {
        return {
          items: props.items || []
        };
      }

      if (props.field && props.field.value && props.field.value.length !== state.selectedItems.length) {
        return {
          inputValue: "",
          selectedItems: getSelectedItems(props)
        };
      }

      return null;
    }
  }]);

  return MultiSelect;
}(_react.Component);

var styles = function styles(theme) {
  return {
    root: {
      display: "flex",
      alignItems: "center",
      width: "100%",
      minHeight: "40px",
      backgroundColor: theme.colors.white,
      border: "1px solid ".concat(theme.colors.gray300),
      padding: "2px 12px 2px 8px",
      cursor: function cursor(props) {
        return props.disabled ? "not-allowed" : "default";
      }
    },
    tagWrapper: {
      display: "flex",
      alignItems: "center",
      overflowX: "auto"
    },
    input: {
      color: "inherit",
      fontFamily: "inherit",
      fontWeight: "400",
      fontSize: "16px",
      lineHeight: "20px",
      border: "none",
      outline: "none",
      cursor: "inherit",
      boxShadow: "none",
      // Reset default inputs for mozilla
      "-webkit-appearance": "none",
      // Reset default browser styles
      "-moz-appearance": "none" // Reset default browser styles

    },
    arrow: {
      flexShrink: "0",
      display: "block",
      marginLeft: "auto"
    },
    dropdown: {
      position: "absolute",
      zIndex: theme.zIndex["selectDropdown"],
      width: "100%",
      maxHeight: "200px",
      cursor: "default",
      backgroundColor: theme.colors.white,
      border: "1px solid ".concat(theme.colors.gray300),
      boxShadow: theme.globalBoxShadow,
      // Add back focus style
      marginTop: "-1px",
      // force overlapping border with input
      overflowY: "scroll",
      WebkitOverflowScrolling: "touch"
    },
    dropdownItem: {
      fontSize: "16px",
      lineHeight: "20px",
      fontWeight: "400",
      padding: "8px 12px"
    },
    dropdownItemNote: {
      fontSize: "14px",
      position: "absolute",
      right: "10px",
      color: theme.colors.gray400
    },
    dropdownItemActive: {
      backgroundColor: theme.colors.gray100
    },
    dropdownItemSelected: {
      backgroundColor: theme.colors.gray200
    }
  };
};

var _default = (0, _withStyles["default"])(styles, {
  name: "EuiMultiSelect"
})(MultiSelect);

exports["default"] = _default;